import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BATCHES_VIEW_ID } from './view-id-constants';

export const Batches = {
  label: <FormattedMessage defaultMessage='Batches' description='shippingPage.nav.batches' id='q1Qqa3' />,
  id: BATCHES_VIEW_ID,
};
